import api from "@/http/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";

// Actual API call to deactivate staff
const deActivateStaff = (staffId: string, status: number) => {
  return api.post(`/staff/staffAccount/${staffId}`, {
    status,
  });
};

// Custom hook to use in components
export const useDeactivateStaff = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ staffId, status }: { staffId: string; status: number }) =>
      deActivateStaff(staffId, status),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["allStaff",] });
    },
    onError: (error) => {
      console.error("Failed to deactivate staff:", error);
    },
  });
};
